import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

import { ID } from "common/entities/IEntity";
import { EntityMultiSelect } from "common/form/fields/entitySelect/EntityMultiSelect";
import Entry from "./entities/Entry";

// const EntrySelect = EntitySelect.registered(Entry, {pageSize: 200}, "id", "product.name");
const EntriesSelect = EntityMultiSelect.registered(Entry, {pageSize: 200}, {valueKey: "id", nameKey: "product.name"});

@Form({title: "Featured Panel Config"})
export class FeaturedPanelConfig {

	@Input({type: InputType.TEXT, title: "Launch link text"})
	public launchLinkText: string;

	@Input({type: EntriesSelect, title: "Featured Entries", required: true})
	public entryIds: ID[];

	@Input({type: InputType.UNIT, title: "Spacing"})
	public spacing?: string;

}



// WEBPACK FOOTER //
// ./src/panels/featured/FeaturedPanelConfig.ts